<template>
    <div>
        <h6 class="heading-small text-muted mb-4">{{ $translate('signature') }}</h6>

        <template v-if="!!order.completed">
            <b-row>
                <img :src="order.signature_data" class="w-100" />
            </b-row>
            <hr />
            <b-row class="pt-2">
                <b-col cols="6" md="2">
                    <strong>{{ $translate('comments') + ':' }}</strong>
                </b-col>
                <b-col>{{ order.signee }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="6" md="2">
                    <strong>{{ $translate('signature_by') }}</strong>
                </b-col>
                <b-col>{{ order.completed_by.first_name + ' ' + order.completed_by.last_name }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="6" md="2">
                    <strong>{{ $translate('signed_at') }}</strong>
                </b-col>
                <b-col>{{ signature_address && signature_address[0] && signature_address[0].display_name }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="6" md="2">
                    <strong>{{ $translate('completed') }}:</strong>
                </b-col>
                <b-col>{{ order.completed_at | filterLocalDateTime }}</b-col>
            </b-row>
        </template>
        <div v-else-if="order.signature === 0" style="padding: 1em 0; text-align: center">
            {{ $translate('received_by_note') }}
        </div>
        <div v-else style="padding: 1em 0; text-align: center">
            {{ $translate('no_signature_data') }}
        </div>
    </div>
</template>

<script>
import moment from "moment"
import dateTimeMixins from '@/mixins/dateTimeMixins'
export default {
    name: 'orders-signature',
    mixins: [ dateTimeMixins ],
    data() {
        return {
            signature_address: null
        }
    },
    filters: {
        formatDateTime(date) {
            return moment(date).format('YYYY-MM-DD hh:mm:ss A')
        },
    },
    props: {
        order: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    methods: {
    },
    mounted() { },
    computed: {
        imagedata() {
            if (this.order) {
                return 'data:image/png;base64,' + this.order.signature_data
            } else {
                return null
            }
        },
    },
    watch: {
        order: {
            immediate: true,
            handler: async function (val) {
                if (val.signature_lat != null && val.signature_long != null) {
                    const getAddress = await this.$store.dispatch(
                        'orders/geocodeStreet',
                        { lat: val.signature_lat, long: val.signature_long }
                    )
                    this.signature_address = getAddress
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped></style>